import React from 'react';
import { Button } from '@ss/mtd-react';
import useGo from '@utils/navigate';
import './index.scss';

const NotFound = () => {
  const { go } = useGo();
  return (
    <div className="zp_notFound">
      <img src={require('@imgs/not_found.png')} alt="" />
      <h3>没有找到页面</h3>
      <p>你访问的页面没有找到，请返回首页重试</p>
      <Button
        size="large"
        onClick={() => {
          go('/home');
        }}
      >
        返回首页
      </Button>
    </div>
  );
};

export default NotFound;
